import styled, { css } from 'styled-components';

/**
 * @component
 */
export const TextStyles = styled.div``;

export const Bold = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

export const Italic = styled.span`
  font-style: italic;
`;

export const Underline = styled.span`
  text-decoration: underline;
`;

export const ellipsis = () => css`
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
`;

export const ellipsesMultipleLines = (numberOfLines = 1) => css`
  display: block; /* Fallback for non-webkit */
  display: -webkit-box;
  max-width: 100%;
  max-height: ${({ theme: { fonts } }) => (
    parseInt(fonts.default.fontSize, 10) * fonts.default.lineHeight * numberOfLines
  )}; /* Fallback for non-webkit */
  font-size: ${props => props.theme.fonts.default.fontSize};
  line-height: ${props => props.theme.fonts.default.lineHeight};
  -webkit-line-clamp: ${numberOfLines};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const nowrap = () => css`
  white-space: nowrap;
`;
